var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"400","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('EpsImportLeadForm',{on:{"cancel":function($event){return _vm.close()},"submitted":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }